import axiosClient from "@/api/common/axiosClient.ts";

export const resetPassword = ({ email }: { email: string }) => {
  return axiosClient.post("users/password_reset/", {
    email,
  });
};

export const resetPasswordValidateToken = ({ token }: { token: string }) => {
  return axiosClient.post("users/password_reset/validate_token/", {
    token,
  });
};

export const resetPasswordConfirm = ({
  token,
  password,
}: {
  token: string;
  password: string;
}) => {
  return axiosClient.post("users/password_reset/confirm/", {
    token,
    password,
    confirm_password: password,
  });
};
